import { gql } from '@apollo/client';

const workflowFragment = gql`
  fragment workflowInfo on Workflow {
    id
    name
    triggerEventNames
    createdAt
    updatedAt
    creatorUserId
    updatedByUserId
    description
    enabled
    visitorTrackingEnabled
    isArchived
    labels {
      id
      name
    }
    workflowReference {
      id
      workflowType
      updatedAt
      updatedByUserId
    }
    workflowType
    allTriggeredByWorkflows {
      workflow {
        name
        id
      }
    }
    startNode {
      id
      resourceName
      nodeData {
        __typename
        ... on TriggeredCustomEventTrigger {
          eventName
        }

        ... on UnsubscribedFromChannelTrigger {
          channelId
        }

        ... on ClickedAnEmailTrigger {
          emailCampaignId
        }
        ... on ClickedAnInAppTrigger {
          emailCampaignId
        }
        ... on OpenedAnEmailTrigger {
          emailCampaignId
        }
        ... on OpenedAnInAppTrigger {
          emailCampaignId
        }
        ... on OpenedPushTrigger {
          emailCampaignId
        }

        ... on ScheduledRecurringListTrigger {
          emailListId
        }
        ... on SubscribedToListTrigger {
          emailListId
        }
        ... on UnsubscribedFromListTrigger {
          emailListId
        }

        ... on FieldChangedTrigger {
          field
        }
      }
    }
  }
`;

export const fetchIndexPageWorkflowsQuery = gql`
  ${workflowFragment}

  query getWorkflows(
    $filterInfo: WorkflowFilterInfoInput
    $pagination: Pagination
    $sort: Sort
    $search: String
  ) {
    workflows(filterInfo: $filterInfo, pagination: $pagination, sort: $sort, search: $search) {
      info {
        count
        offset
        limit
        page
      }
      results {
        ...workflowInfo
      }
    }
  }
`;

export const fetchWorkflowCampaignNodesQuery = gql`
  query getWorkflowCampaignNodes(
    $workflowId: Long!
    $workflowType: WorkflowType
    $nodeResources: [WorkflowNodeResourceFilter!]
  ) {
    workflow(id: $workflowId, workflowType: $workflowType, nodeResources: $nodeResources) {
      startNode {
        id
        nodeData {
          __typename
        }
      }
      edges {
        srcWorkflowNodeId
        destWorkflowNodeId
      }
      allNodes {
        id
        resource {
          ... on CampaignNodeResource {
            campaign {
              id
              name
              templateId
              dataScienceOptimizations
              messageMedium
              customQuietHours {
                startTime
                endTime
                sendSkip
              }
            }
          }
        }
      }
    }
  }
`;

export const fetchTreeViewWorkflowsQuery = gql`
  query getTreeViewWorkflows($pagination: Pagination, $folderId: Long, $content: [ContentFilter!]) {
    workflowFolder(pagination: $pagination, folderId: $folderId, content: $content) {
      id
      name
      ancestors {
        id
        name
      }
      content {
        ... on WorkflowSubfolder {
          id
          name
        }
      }
    }
  }
`;

export const fetchIndexPageWorkflowFoldersQuery = gql`
  ${workflowFragment}

  query getWorkflowFolders(
    $filterInfo: WorkflowFilterInfoInput
    $pagination: Pagination
    $sort: Sort
    $search: String
    $folderId: Long
    $recursive: Boolean
    $content: [ContentFilter!]
  ) {
    workflowFolder(
      filterInfo: $filterInfo
      pagination: $pagination
      sort: $sort
      search: $search
      folderId: $folderId
      recursive: $recursive
      content: $content
    ) {
      id
      name
      info {
        count
        offset
        limit
        page
      }
      ancestors {
        id
        name
      }
      content {
        ... on WorkflowSubfolder {
          id
          name
        }
        ...workflowInfo
      }
    }
  }
`;

export const fetchIndexPageCreatorsAndModifiers = gql`
  fragment userInfo on User {
    id
    fullName
    avatarUrl
  }
  query getWorkflowCreatorsAndModifiers {
    workflowCreators {
      ...userInfo
    }
    workflowModifiers {
      ...userInfo
    }
  }
`;
